import { getTest, getTestResult } from "src/api/testResult";
import { makeAutoObservable } from "mobx";
import historyStore from "./HistoryStore";
// Types
import { TestResult } from "../types/TestResult";
// Routes
import { TEST_RESULT_PREVIEW } from "src/constants/routes";

class TestResultStore {
  constructor() {
    makeAutoObservable(this);
  }

  testResult: TestResult | null = null;
  testeeFullName: string | null = null;
  supervisionId: string | null = null;
  codeNew = false;
  scanInProgress = false;
  alert: any;

  setTestResult(testResult: TestResult | null) {
    this.testResult = testResult;
  }

  setTesteeFullName(fullName: string) {
    this.testeeFullName = fullName;
  }

  setSupervisionId(supervisionId: string) {
    this.supervisionId = supervisionId;
  }

  loadTestResult(id: string) {
    getTest(id)
      .then((test) => {
        console.log(test);
        if (!test.result) {
          this.codeNew = true;
          return;
        }
        getTestResult(test.result).then((result) => {
          this.testResult = result;
          console.log(result);
          if (result.testSupervisorType !== "SELF") {
            this.setSupervisionId(result.supervision?.id);
            historyStore.navigate(TEST_RESULT_PREVIEW);
            this.scanInProgress = false;
          } else {
            this.alert.show("This test was self validated", { type: "error" });
            setTimeout(() => (this.scanInProgress = false), 3000);
          }
        });
      })
      .catch(() => {
        this.alert.show("The test was not found.", { type: "error" });
        setTimeout(() => (this.scanInProgress = false), 3000);
      });
  }
}

const testResultStore = new TestResultStore();

export default testResultStore;
